// Eventos de Google Analytics 4 (GA4 G-4R64C31TQM, cargado por Tag Manager
// desde public/index.html). gtag() está definido ahí mismo; si GTM todavía no
// termina de cargar, los eventos quedan en dataLayer y se envían al cargar.
//
// Eventos que se miden (marcar como key event en GA4 → Admin → Events):
//   - whatsapp_click : clic en cualquier enlace a WhatsApp (botón flotante, etc.)
//   - generate_lead  : formulario de contacto o de cotización enviado con éxito
//   - email_click    : clic en un enlace mailto:
//   - phone_click    : clic en un enlace tel:

export function trackEvent(name, params = {}) {
  if (typeof window === 'undefined' || typeof window.gtag !== 'function') return
  window.gtag('event', name, {
    page_path: window.location.pathname,
    ...params
  })
}

// Un solo listener para todo el sitio: no hay que tocar cada botón.
export function initClickTracking() {
  if (typeof document === 'undefined') return
  document.addEventListener('click', (e) => {
    const a = e.target && e.target.closest ? e.target.closest('a[href]') : null
    if (!a) return
    const href = a.getAttribute('href') || ''
    let name = null
    if (/^https:\/\/(wa\.me|api\.whatsapp\.com|wa\.link)\//i.test(href)) name = 'whatsapp_click'
    else if (href.startsWith('mailto:')) name = 'email_click'
    else if (href.startsWith('tel:')) name = 'phone_click'
    if (!name) return
    trackEvent(name, {
      link_text: (a.getAttribute('aria-label') || a.textContent || '').trim().slice(0, 100),
      transport_type: 'beacon'
    })
  }, { capture: true })
}
